import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

import { CardLabelContainer } from '../../CardLabelContainer';
import { LabelsLayout } from '../components/LabelsLayout';

export const LabelsContainer = memoWithDisplayName(() => {
  const {
    extendedProperties: { labels },
  } = useCardOfferDataContext();

  if (!labels.length) {
    return null;
  }

  return (
    <LabelsLayout>
      {labels.map(label => (
        <CardLabelContainer key={label} type={label} />
      ))}
    </LabelsLayout>
  );
}, 'PublisherBadgesContainer');
